import type {ComponentStageData, ComponentStageHeuristicDefinition} from '../../types'
import {updateTargetLayout} from '../common'
import {getTargetLayoutPointer} from '../../conversionDal/utils/pointer'
import {deepClone} from '@wix/wix-immutable-proxy'

const fr = {type: 'fr', value: 1}

export const containerColumnsHeuristicsAdaptive: ComponentStageHeuristicDefinition[] = [
    {
        predicate: ({componentPointer, conversionDal}: ComponentStageData) => {
            const component = conversionDal.get(componentPointer)
            return component.type === 'Container' && !component.isSlottedComponent
        },
        apply: (componentStageData: ComponentStageData) => {
            const {componentPointer, conversionDal} = componentStageData
            const {containerLayout} = deepClone(conversionDal.get(getTargetLayoutPointer(componentPointer))) ?? {}

            updateTargetLayout(componentStageData, {
                containerLayout: {
                    ...containerLayout,
                    columns: [
                        {
                            type: 'MinMaxSize',
                            min: {type: 'px', value: 0},
                            max: fr
                        }
                    ],
                    type: 'GridContainerLayout'
                }
            })
        },
        heuristicCode: 'SINGLE COLUMN LAYOUT'
    }
]
